export const GET_ACTIVE_DEALER = 'get-active-dealer';
export const UPDATE_ACTIVE_DEALER = 'update-active-dealer';
